import { render, staticRenderFns } from "./b2b-list-item-title.vue?vue&type=template&id=7d934e9e&functional=true"
import script from "./b2b-list-item-title.vue?vue&type=script&lang=js"
export * from "./b2b-list-item-title.vue?vue&type=script&lang=js"
import style0 from "./b2b-list-item-title.vue?vue&type=style&index=0&id=7d934e9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports